import { Star } from "lucide-react";
import { TableRow, TableCell } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CalculateDialog from "./CalculateDialog";

const SignalRow = ({ coin, icon, type, leverage, direction, date, entry, targets, profit, hitTarget, progressGreen, progressRed, navigation, condition }) => {
  const navigate = useNavigate();
  return (
    <TableRow className='signalView-row' sx={{ '& > *': { borderBottom: 'unset' } }}>
      <TableCell component="th" scope="row" sx={{ paddingY: 0, paddingX: '4px', flex: 1, fontSize: { xs: '0.7rem', lg: '0.9rem' }, border: 'none' }} align="left">
        <div className="signalView-coin">
          <div className="signalView-coin-icon">
            {icon ? (
              <img src={icon} alt="coin" width={24} />
            ) : <p className="signalView-img-text">{coin?.[0]}{coin?.[1]}{coin?.[2]}</p>}
          </div>

          <div>
            <div className="signalView-coin-top">
              <span className="signalView-coin-name" onClick={() => navigate(navigation)}>{coin}</span>
              <Star className="signalView-star" />
            </div>

            <div className="signalView-coin-meta">
              <span className="signalView-badge-primary">
                {type}
              </span>

              {leverage || direction ? <span className="signalView-badge-secondary">
                {leverage && `${leverage} · `}{direction}
              </span> : null}
            </div>
            <p className="signalView-date">{date}</p>
          </div>
        </div>
      </TableCell>

      <TableCell sx={{ paddingY: 0, paddingX: '4px', flex: 1, fontSize: { xs: '0.7rem', lg: '0.9rem' }, border: 'none' }} align="left">
        <div className="signalView-entry">
          <p className="signalView-label-sm">Entry</p>
          <p className="signalView-value-sm">{entry}</p>
        </div>
      </TableCell>

      <TableCell sx={{ paddingY: 0, paddingX: '4px', flex: 4, fontSize: { xs: '0.7rem', lg: '0.9rem' }, border: 'none' }} align="left">
        <div className="signalView-targets">
          {targets?.slice(0, 1).map((t) => (
            <div
              key={t.label}
              className={`signalView-target-box ${t.isSl
                ? "signalView-target-loss"
                : t.hit
                  ? "signalView-target-profit"
                  : "signalView-target-default"
                }`}
            >
              <div className="signalView-target-top">
                <span
                  className={`signalView-target-label ${t.isSl ? "signalView-text-loss" : ""
                    }`}
                >
                  {t.label}
                </span>

                {t.hit && <span className="signalView-check">✓</span>}
              </div>

              <p className="signalView-target-price">{t.price}</p>
              <p
                className={`signalView-target-percent ${t.isSl ? "signalView-text-loss" : "signalView-text-profit"
                  }`}
              >
                {t.percent}
              </p>
            </div>
          ))}
        </div>
      </TableCell>
      <TableCell sx={{ paddingY: 0, paddingX: '4px', flex: 4, fontSize: { xs: '0.7rem', lg: '0.9rem' }, border: 'none' }} align="left">
        <div className="signalView-targets">
          {targets?.slice(1, 2).map((t) => (
            <div
              key={t.label}
              className={`signalView-target-box ${t.isSl
                ? "signalView-target-loss"
                : t.hit
                  ? "signalView-target-profit"
                  : "signalView-target-default"
                }`}
            >
              <div className="signalView-target-top">
                <span
                  className={`signalView-target-label ${t.isSl ? "signalView-text-loss" : ""
                    }`}
                >
                  {t.label}
                </span>

                {t.hit && <span className="signalView-check">✓</span>}
              </div>

              <p className="signalView-target-price">{t.price}</p>
              <p
                className={`signalView-target-percent ${t.isSl ? "signalView-text-loss" : "signalView-text-profit"
                  }`}
              >
                {t.percent}
              </p>
            </div>
          ))}
        </div>
      </TableCell>
      <TableCell sx={{ paddingY: 0, paddingX: '4px', flex: 4, fontSize: { xs: '0.7rem', lg: '0.9rem' }, border: 'none' }} align="left">
        <div className="signalView-targets">
          {targets?.slice(2, 3).map((t) => (
            <div
              key={t.label}
              className={`signalView-target-box ${t.isSl
                ? "signalView-target-loss"
                : t.hit
                  ? "signalView-target-profit"
                  : "signalView-target-default"
                }`}
            >
              <div className="signalView-target-top">
                <span
                  className={`signalView-target-label ${t.isSl ? "signalView-text-loss" : ""
                    }`}
                >
                  {t.label}
                </span>

                {t.hit && <span className="signalView-check">✓</span>}
              </div>

              <p className="signalView-target-price">{t.price}</p>
              <p
                className={`signalView-target-percent ${t.isSl ? "signalView-text-loss" : "signalView-text-profit"
                  }`}
              >
                {t.percent}
              </p>
            </div>
          ))}
        </div>
      </TableCell>
      <TableCell sx={{ paddingY: 0, paddingX: '4px', flex: 4, fontSize: { xs: '0.7rem', lg: '0.9rem' }, border: 'none' }} align="left">
        <div className="signalView-targets">
          {targets?.slice(3, 4).map((t) => (
            <div
              key={t.label}
              className={`signalView-target-box ${t.isSl
                ? "signalView-target-loss"
                : t.hit
                  ? "signalView-target-profit"
                  : "signalView-target-default"
                }`}
            >
              <div className="signalView-target-top">
                <span
                  className={`signalView-target-label ${t.isSl ? "signalView-text-loss" : ""
                    }`}
                >
                  {t.label}
                </span>

                {t.hit && <span className="signalView-check">✓</span>}
              </div>

              <p className="signalView-target-price">{t.price}</p>
              <p
                className={`signalView-target-percent ${t.isSl ? "signalView-text-loss" : "signalView-text-profit"
                  }`}
              >
                {t.percent}
              </p>
            </div>
          ))}
        </div>
      </TableCell>

      <TableCell sx={{ paddingY: 0, paddingX: '4px', flex: 2, fontSize: { xs: '0.7rem', lg: '0.9rem' }, border: 'none' }} align="left">
        <div className="d-flex justify-content-between align-items-center ps-2" style={{ gap: '8px' }}>
          <div className="signalView-profit-box">

            <p className="signalView-label-sm">Profit</p>

            <div className="signalView-profit-top">
              <p className={`${condition > 0 ? 'signalView-profit-value' : 'signalView-loss-value'}`}>{profit}</p>
              <p className="signalView-hit">{hitTarget}</p>
            </div>

            <div className="signalView-progress-wrapper">

              <span className="signalView-progress-text">{progressGreen}%</span>

              <div className="signalView-progress">
                <div className="signalView-progress-green" style={{ width: `${progressGreen}%` }}></div>
                <div className="signalView-progress-red" style={{ width: `${progressRed}%` }}></div>
              </div>

              <span className="signalView-progress-text">{progressRed}%</span>

            </div>

          </div>
          <div>
            <CalculateDialog signal={{
              pair: coin,
              type: type,
              leverage: leverage || "",
              direction: direction || "",
              entry: entry,

              targets: targets
                ?.filter(t => t.label !== "SL")
                .map(t => ({
                  label: t.label,
                  price: t.price,
                  percent: t.percent,
                  hit: t.hit || false,
                })),

              stopLoss: targets?.find(t => t.label === "SL")
                ? {
                  price: targets.find(t => t.label === "SL").price,
                  percent: targets.find(t => t.label === "SL").percent,
                  hit: targets.find(t => t.label === "SL").isSl || false,
                }
                : null,
            }} />
          </div>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default SignalRow;
